import { createContext } from "react";
import { MenuListItems } from "../common/Sidebar/MenuListItems";
import { SSO_WEB_EXCHANGE } from "../constants/api-constants";
import { SystemModulesEnum } from "../constants/SystemUsers";
import PublicApiServices from "../services/PublicApiServices";

export const AuthInit = {
  currentUser: null,
  setCurrentUser(user) {
    localStorage.setItem("currentUser", JSON.stringify(user));
    this.currentUser = user;
  },
  getCurrentUser() {
    if (this.currentUser) {
      return this.currentUser;
    } else {
      return JSON.parse(localStorage.getItem("currentUser"));
    }
  },
  async ssoLogin(code) {
    if (!code) {
      return { success: false };
    }
    const response = await PublicApiServices.httpPost(SSO_WEB_EXCHANGE, {
      code,
    });
    if (response.responseStatus?.isSuccess === true) {
 
      const ssoLoginData = {
        token: response.result.token,
        expiresOnUtc: response.result.expiresOnUtc,
        user: response.result.user,
        is2FA: response.result.is2FA,
      };
      localStorage.setItem("ssoResponse", JSON.stringify(response));
      localStorage.setItem("ssoLoginData", JSON.stringify(ssoLoginData));
      localStorage.setItem("ssoAdminData", "true");
      localStorage.removeItem("purchase_filters");

      // Check returnUrl and determine redirect path
      const returnUrl = response.result?.returnUrl || "";
      const lowerReturnUrl = returnUrl.toLowerCase();
      const shouldRedirectToCart =
        lowerReturnUrl.includes("folderrecieved") ||
        lowerReturnUrl.includes("home") ||
        lowerReturnUrl.includes("editpackage") ||
        lowerReturnUrl.includes("packagereceived") ||
        lowerReturnUrl.includes("efwimport");
      const isMigration = lowerReturnUrl.includes("efwimport");
      return {
        success: true,
        redirectToCart: shouldRedirectToCart,
        returnUrl: returnUrl,
        isMigration: isMigration,
      };
    }
    return {
      success: false,
      error:
        response.responseStatus?.error ||
        "The sign-in link is invalid or has expired. Please try again.",
    };
  },
  setRole(role) {
    localStorage.setItem("selectedRole", role.roleTypes[0].userType);
    localStorage.setItem("roleId", role.roleId);
    localStorage.setItem("roleName", role.name);
  },
  getRole() {
    const role = localStorage.getItem("selectedRole");
    return role ? Number(role) : 0;
  },
  getRoleId() {
    const roleId = localStorage.getItem("roleId");
    return roleId ? Number(roleId) : 0;
  },
  setInternalRole(internalRole) {
    localStorage.setItem("selectedInternalRole", internalRole);
  },
  getPermissionId() {
    const role = Number(localStorage.getItem("selectedRole") || 0);
    const internalRole = Number(
      localStorage.getItem("selectedInternalRole") || 0,
    );
    const whenNotRoles_3_5 = role === 4 && internalRole ? 6 : role;
    const permissionId = role === 3 && internalRole ? 5 : whenNotRoles_3_5;
    return permissionId ? Number(permissionId) : 0;
  },
  setModules(modules) {
    const currentRole = Number(localStorage.getItem("selectedRole") || 0);
    const incomingModules = Array.isArray(modules) ? modules : [];

    let modName = {
      64: "Content",
    };
    let commonModules = MenuListItems.map((item) => {
      const matchedModule = incomingModules.find((mod) =>
        [64].includes(item.moduleId)
          ? mod.name === modName[item.moduleId]
          : mod.name === item.name,
      );

      return {
        ...item,
        features: matchedModule?.features || [],
        childMenu: [],
        subMenu: [],
      };
    });

    let parentModules = commonModules.filter(
      (item) =>
        item.pModuleId === 0 &&
        (item.name === "Dashboard" ||
          item.features?.some((x) => x.featureName === "List")),
    );

    // ADMIN FIX: Ensure Admin gets same AddIns permissions as SuperAdmin
    const addInsModuleIndex = parentModules.findIndex(m => m.moduleId === 67);

    const hasAddInsFromApi = incomingModules.some(
      (mod) => mod?.name === SystemModulesEnum.ADDINS,
    );

    if (
      (currentRole === 1 || currentRole === 2) &&
      addInsModuleIndex === -1 &&
      hasAddInsFromApi
    ) {
      const addInsModule = commonModules.find(m => m.moduleId === 67);
      if (addInsModule) {
        // Force both SuperAdmin and Admin to have permissions
        addInsModule.features = [
          { featureName: "List" },
          { featureName: "Create" },
          { featureName: "Update" }
        ];
        parentModules.push(addInsModule);
        // Added AddIns permissions for role
      }
    }

    // ADV BANNERS FORMULA: ensure child module has features so it appears in Setup submenu
    if (currentRole === 1 ) {
      const advBannersChild = commonModules.find(m => m.moduleId === 71);
      if (advBannersChild && (!advBannersChild.features || advBannersChild.features.length === 0)) {
        advBannersChild.features = [
          { featureName: "List" },
          { featureName: "Create" },
          { featureName: "Update" }
        ];
      }
    }
    let childModules = commonModules.filter(
      (item) => item.pModuleId !== 0 && item.features,
    );

    localStorage.setItem("rolesNavigation", JSON.stringify(parentModules));
    localStorage.setItem("rolesChildModules", JSON.stringify(childModules));

    childModules.forEach((child) => {
      // Only add child if it has List permission
      const hasList = child.features?.some(f => f.featureName === "List");
      if (hasList) {
        parentModules.forEach((parent) => {
          if (parent.name === child.parentModuleName && !child.isSubMenu) {
            parent.childMenu.push(child);
            parent.features.push();
          } else if (parent.name === child.parentModuleName && child.isSubMenu) {
            parent.subMenu.push(child);
            parent.features.push();
          }
        });
      }
    });

    parentModules.sort((a, b) => {
      return a.displayOrder - b.displayOrder;
    });
    // add dashboard as default menu item for all roles
    localStorage.setItem(
      "modulePermissions",
      JSON.stringify([MenuListItems[0], ...parentModules]),
    );
  },
  getModules() {
    return JSON.parse(localStorage.getItem("modulePermissions"));
  },
  setBrandImage(imageUrl) {
    localStorage.setItem("brandImage", imageUrl);
  },
  getBrandImage() {
    return localStorage.getItem("brandImage");
  },
};

export const AuthContext = createContext(AuthInit);
